module.exports = __webpack_public_path__ + "static/media/hero-1.636ae715.jpg";